<template>
    <v-container>
        <v-card hover height=90 style="border-radius: 8px;" :href="publishurl" target="_blank">
            <v-layout>             
            <v-flex xs8>
                <div class="title font-weight-regular ml-5 mt-4"> Publish your bot to get discoverd on facebook bots</div>
            </v-flex> 
            <v-flex xs2>
                <v-btn class="ml-5 mt-3" color="primary" flat round>publish now</v-btn>
            </v-flex> 
            </v-layout>
        </v-card>       
    </v-container>
</template>

<script>
export default {
    data(){
        return{
           gnote:null
        }
    },
    methods:{
        saveGnote(){

        }
    },
    computed:{
        publishurl(){
            let pageid = this.$route.params.page_id
            return 'https://www.facebook.com/'+pageid+'/settings/?tab=messenger_platform'
        }
    }    
}
</script>
